import { useStore } from '../../app/StoreContext';

const ORDER = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export function Hours() {
  const { store } = useStore();
  const hours = store?.hours || {};
  const keys = Object.keys(hours).sort((a, b) => {
    const ia = ORDER.indexOf(a.toLowerCase()), ib = ORDER.indexOf(b.toLowerCase());
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
  const todayKey = ORDER[(new Date().getDay() + 6) % 7];
  return (
    <div className="page-narrow">
      <h1>Hours</h1>
      {keys.length === 0 && <p className="muted">Hours have not been published.</p>}
      <dl className="hours">
        {keys.map((k) => (
          <div key={k} className={`hours-row ${k.toLowerCase() === todayKey ? 'today' : ''}`}>
            <dt>{k.charAt(0).toUpperCase() + k.slice(1)}</dt>
            <dd>{hours[k]}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
